import React, { useState } from "react";
import InputMask from "react-input-mask";
import {
  Box,
  Button,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import PropTypes from "prop-types";

const OptInForm = ({ onSubmit, onCancel }) => {
  const [phone, setPhone] = useState("");
  const [checked, setChecked] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (phone.length < 14) {
      setError("Please enter a valid phone number.");
      return;
    }
    if (!checked) {
      setError("You must agree to receive messages before continuing.");
      return;
    }
    setError("");
    onSubmit(phone);
  };

  return (
    <Box
      className="p-8 bg-white rounded-lg shadow-xl mx-auto"
      sx={{
        maxWidth: 500,
        textAlign: "center",
        borderRadius: "12px",
      }}
    >
      <Typography variant="h5" className="!mb-6 !font-bold !text-3xl">
        Stay Updated via Text Messages
      </Typography>

      <form onSubmit={handleSubmit}>
        <InputMask
          mask="(999) 999-9999"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        >
          {(inputProps) => (
            <TextField
              {...inputProps}
              fullWidth
              variant="outlined"
              label="Mobile Phone Number"
              placeholder="(123) 456-7890"
              error={!!error && phone.length < 14}
              sx={{ mb: 2 }}
            />
          )}
        </InputMask>

        {/* Terms and Privacy Agreement with Checkbox */}
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={() => setChecked(!checked)}
              color="primary"
            />
          }
          label={
            <Typography
              variant="body2"
              sx={{ color: "gray.700", textAlign: "left" }}
            >
              By submitting this form and entering your phone number above, you
              agree to receive automated text messages from E3 Company and agree
              to our{" "}
              <a
                href="/terms"
                style={{ color: "#2563EB", textDecoration: "underline" }}
              >
                Terms and Privacy.
              </a>{" "}
              If you choose to decline, you can sign up later by visiting the
              **Settings → My Profile** tab.
            </Typography>
          }
        />

        {error && (
          <Typography color="error" sx={{ mt: 1 }}>
            {error}
          </Typography>
        )}

        {/* Send Button */}
        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{
            bgcolor: "#22C55E",
            color: "white",
            mt: 3,
            py: 1.2,
            fontSize: "1rem",
            "&:hover": { bgcolor: "#1DA44C" },
          }}
        >
          Send
        </Button>

        {/* No Thanks Button */}
        <Button
          onClick={onCancel}
          className="!mt-4 !normal-case"
          sx={{
            display: "block",
            margin: "0 auto",
            textTransform: "none",
            color: "#2563EB",
            fontSize: "1rem",
            "&:hover": { textDecoration: "underline" },
          }}
        >
          No Thanks
        </Button>
      </form>
    </Box>
  );
};

OptInForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default OptInForm;
